import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Section, Text, Button} from 'components/UIKit';
import * as locales from './locales';
import {pattern, pattern2x, trust} from './images';
import styles from './ListingTrust.scss';

export interface ListingTrustProps {
  link: string;
}

const POINT_I18N_KEYS = ['verifiedRevenue', 'secureMessaging', 'escrowPayment', 'migrationTeam'];

function ListingTrustComponent({link = '', i18n}: ListingTrustProps & WithI18nProps) {
  return (
    <Section spacing="small" fullWidth>
      <div className={styles.Container}>
        <img className={styles.Thumb} aria-hidden alt="" src={trust} />
        <Text type="h5" text={i18n.translate('secureExperience')} component="p" inheritColor />
        <Text type="h2" text={i18n.translate('trust')} inheritColor />
        <ul>
          {POINT_I18N_KEYS.map((point) => (
            <li className={styles.List} key={point}>
              <Text inheritColor text={i18n.translate(point)} />
            </li>
          ))}
        </ul>
        <Button light url={link} label={i18n.translate('learnMore')} />
        <img
          alt=""
          aria-hidden
          src={pattern}
          srcSet={`${pattern} 1x, ${pattern2x} 2x`}
          className={styles.BgPattern}
        />
      </div>
    </Section>
  );
}

export const ListingTrust = withI18n({
  id: 'ListingTrust',
  fallback: locales.en,
})(ListingTrustComponent);

export default ListingTrust;
